import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ModalDialog from '@/components/ModalDialog/ModalDialog';
import { AppContext } from '@/AppContext';
import ErrorBlock from '@/components/ErrorBlock/ErrorBlock';
import { Grid, TextField } from '@mui/material';
import { convertErrors, MyFormTextField } from '../../../MeetupList/components/MeetupEditForm/MeetupEditForm';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const ChangeServicePlan = props => {
  const appContext = useContext(AppContext);
  const { accountId } = useParams();
  const { goBack } = props;

  const [errors, setErrors] = useState([]);

  const [formState, setFormState] = useState({
    values: {
      planId: '',
      deferred: false,
      noCharge: false,
      comment: '',
    },
    errors: {},
    touched: {},
    isValid: true,
  });

  const [tariffs, setTariffs] = useState(undefined);
  useEffect(() => {
    appContext.configApi
      .getServicePlanConfig()
      .then(({ data }) => {
        setTariffs(data);
      })
      .catch(appContext.errorHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = () => {
    appContext.accountApi
      .changePlan(accountId, formState.values)
      .then(({ data }) => {
        goBack(data);
      })
      .catch(error => {
        const data = error.response.data;
        setErrors(data.errors || [data]);
      });
  };

  useEffect(() => {
    if (errors) {
      setFormState({
        ...formState,
        ...convertErrors(errors),
      });
    }
  }, [errors]);

  const handleChange = (name, value) => {
    formState.values[name] = value;
    formState.touched[name] = true;

    setFormState(formState => {
      return {
        ...formState,
        isValid: true,
        errors: {},
      };
    });
  };

  const error = field => {
    if (!formState.touched || !formState.errors) {
      return null;
    }
    if (formState.touched[field] && formState.errors[field]) {
      return formState.errors[field];
    } else {
      return null;
    }
  };

  if (!tariffs) {
    return null;
  }

  const form = {
    // form values bind helper
    data: formState,
    handleChange: handleChange,
    error: error,
  };
  return (
    <ModalDialog title={'Смена тарифного плана'} okButtonText={'Сохранить'} handleOk={handleSave} handleClose={goBack}>
      <ErrorBlock message={formState.error} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <TextField
            select
            label='Тарифный план'
            style={{ width: '100%' }}
            value={formState.values.planId}
            onChange={e => handleChange('planId', e.target.value)}
            margin='dense'
            variant='outlined'
          >
            {tariffs.servicePlans.map(plan => {
              return (
                <MenuItem key={plan.name} value={plan.name}>
                  {plan.name}
                </MenuItem>
              );
            })}
          </TextField>
        </Grid>
        <Grid size={6}>
          <FormControlLabel
            labelPlacement={'start'}
            control={
              <Checkbox
                checked={formState.values.deferred || false}
                name='deferred'
                onChange={e => handleChange('deferred', e.target.checked)}
                inputProps={{
                  'aria-label': 'primary checkbox',
                }}
              />
            }
            label='Отложенное изменение'
          />
        </Grid>
        <Grid size={6}>
          <FormControlLabel
            labelPlacement={'start'}
            control={
              <Checkbox
                checked={formState.values.noCharge || false}
                name='noCharge'
                onChange={e => handleChange('noCharge', e.target.checked)}
                inputProps={{
                  'aria-label': 'primary checkbox',
                }}
              />
            }
            label='Бесплатно'
          />
        </Grid>
        <Grid size={12}>
          <MyFormTextField name={'comment'} label='Комментарий' {...form} />
        </Grid>
      </Grid>
    </ModalDialog>
  );
};

ChangeServicePlan.propTypes = {};

export default ChangeServicePlan;
